'use strict';
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/lmds-react-loading-spinner/node_modules/core-js/internals/hidden-keys.js
// module id = 437
// module chunks = 0